<template>
  <section>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          
            <b-button @click="$router.go(-1)" class="button is-danger is-pulled-left">ย้อนกลับ</b-button>
            
          
          
        </div>
      </div>
      <div class="level-center">
        <div class="level-item">
          
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div class="buttons">
            <button class="button is-success is-pulled-right" v-can="'adjust_inventory'" @click="adjust_inventory">
              <i class="fas fa-save"></i>บันทึก
            </button>
            
            
          </div>
        </div>
      </div>
    </nav>


    <div>
      <div class="level-right">
      <b-input placeholder="Search..." v-model="search_query" type="search" icon="search" icon-pack="fas"></b-input>
      </div>
    </div>
    
    <h1 class="section-head">ปรับยอดสินค้า</h1>

    <div>
      <b-table
        :data="filteredData"
        :hoverable="true"
        :loading="isTableLoading"

        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :pagination-simple="isPaginationSimple"
        :narrowed="true"
      >
        <template slot-scope="props">
          <b-table-column field="id" label="ID" width="50" numeric>
              {{ props.row.id }}
          </b-table-column>

          <b-table-column field="name" label="ชื่อผลิตภัณฑ์" width="300">
              {{ props.row.name }}
          </b-table-column>

          <b-table-column field="sup_name" label="ซัพพลายเออร์" width="200">
              {{ props.row.sup_name }}
          </b-table-column>

          <b-table-column field="price_buy" label="คงเหลือ" width="100" centered>
              <span :class="(props.row.reorder > props.row.in_stock) ? 'alert-reorder':''">{{props.row.in_stock}}</span>
          </b-table-column>

          <b-table-column label="ปรับยอด" width="50" centered>
              <b-input v-model="inventory_update[props.row.id]" type="text" width="50" custom-class="has-text-centered"></b-input>
          </b-table-column>

          <b-table-column label="หน่วย" width="100">
               {{ props.row.unit_sell_text }}
          </b-table-column>

        </template>
      </b-table>
      <div class="notification has-text-centered" v-if="all_product.length == 0 && !isTableLoading">ไม่พบข้อมูล</div>
    </div>
  </section>
</template>

<script>
  import ProductModel from '@/model/product_model'
  import Request from '@/libraries/request'
  import Const from '@/const/const'
  import { Dialog } from "buefy/dist/components/dialog";

  export default {
    name: 'Inventory_Adjustment',
    props: ['supId'],
    components: {
      Dialog,
    },
    data() {
      return {
        all_product: [],
        inventory_update: [],
        lastSelected: {},
        isTableLoading: true,
        isPaginated: true,
        isPaginationSimple: false,
        currentPage: 1,
        perPage: 20,
        search_query: "",
      }
    },
    mounted() {
      this.init();
    },
    computed: {
      filteredData: function() {
        return this.all_product.filter(product => {
          return (
                  (product.code && product.code.toLowerCase().includes(this.search_query.toLowerCase()))
                  || (product.sup_name && product.sup_name.toLowerCase().includes(this.search_query.toLowerCase()))
                  || (product.name && product.name.toLowerCase().includes(this.search_query.toLowerCase()))
                )
        })
      }
    },
    methods: {
      async init(){
        this.all_product = await ProductModel.get_all_product(this.supId);
        this.isTableLoading = false;
      },
      adjust_inventory() {
        this.$buefy.dialog.prompt({
            message: 'กรุณาใส่รหัสผ่านเพื่อยืนยัน',
            confirmText: 'ยืนยัน',
            cancelText: 'ยกเลิก',
            inputAttrs: {
                type: 'password',
                placeholder: 'Password',
                maxlength: 256
            },
            onConfirm: (value) => {
              //TODO: checking password if correct do the bussiness, if not prompt again and display error
              const loadingComponent = this.$buefy.loading.open({});
              const data = {'password': value, 'update_data': this.inventory_update}
              const updatePromise = ProductModel.update_inventory(data);
              updatePromise.then((data) => {
                if(data.status){
                  loadingComponent.close();
                  this.$buefy.toast.open({
                    duration: 5000,
                    message: data.msg,
                    position: 'is-top',
                    type: 'is-success'
                  })
                  this.$router.push('/inventory');
                }else{
                  this.$buefy.toast.open({
                    duration: 5000,
                    message: 'ไม่สามารถปรับยอดสินค้าได้ เนื่องจาก: ' + data.msg,
                    position: 'is-top',
                    type: 'is-danger'
                  })
                  loadingComponent.close();
                  this.adjust_inventory();
                }
              });
              //this.adjust_inventory()
            }
        })
      },

    }
  }
</script>

<style lang="scss" scoped>
  .alert-reorder {
    font-weight: bolder;
    color: #FFF;
    background-color: red;
    padding: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Inventory/adjustment.vue